module.exports = __webpack_public_path__ + "img/oude-donk.20d2c00f.jpg";